/**
 * Demo / showcase data for CreatorHub360.
 * Provides realistic fake responses for all three portals.
 * Toggle with the "Demo" button in the sidebar.
 */

// ── Admin Dashboard ───────────────────────────────────────────────────────

export const DEMO_ADMIN_DASHBOARD = {
  summary: {
    totalRevenue: 247_830,
    totalOrders: 1_842,
    totalInfluencers: 18,
    activeInfluencers: 14,
    avgOrderValue: 134.54,
    totalVendors: 6,
  },
  revenueByDay: (() => {
    const days: Array<{ date: string; revenue: number; orders: number }> = [];
    const base = Date.now() - 29 * 86400000;
    for (let i = 0; i < 30; i++) {
      const d = new Date(base + i * 86400000);
      const rev = 5800 + Math.sin(i * 0.6) * 1900 + Math.random() * 1200;
      days.push({
        date: d.toISOString().slice(0, 10),
        revenue: Math.round(rev),
        orders: Math.round(rev / 134),
      });
    }
    return days;
  })(),
  websitePipeline: { draft: 3, in_review: 5, approved: 6, live: 14 },
  productRequests: { pending: 8, approved: 22, rejected: 3 },
  topInfluencers: [
    { influencer_id: 1, name: 'Sophia Chen',      total_orders: 312, total_revenue: 41_280 },
    { influencer_id: 2, name: 'Marcus Lee',        total_orders: 287, total_revenue: 38_650 },
    { influencer_id: 3, name: 'Aisha Patel',       total_orders: 241, total_revenue: 32_100 },
    { influencer_id: 4, name: 'Jordan Williams',   total_orders: 198, total_revenue: 27_450 },
    { influencer_id: 5, name: 'Luna Park',         total_orders: 176, total_revenue: 24_820 },
    { influencer_id: 6, name: 'Ethan Brooks',      total_orders: 154, total_revenue: 20_960 },
    { influencer_id: 7, name: 'Mia Torres',        total_orders: 132, total_revenue: 18_150 },
    { influencer_id: 8, name: 'Noah Kim',          total_orders: 118, total_revenue: 15_840 },
  ],
  range: '30d',
};

// ── Admin Influencer List (enriched for redesigned card UI) ───────────────

export const DEMO_INFLUENCERS_ENRICHED = [
  {
    id: 1, first_name: 'Charli', last_name: "D'Amelio", stage_name: "Charli D'Amelio",
    influencer_id: 'charlidamelio', slug: 'charlidamelio', storefront_id: 101, status: 'active',
    email: 'charli@damelio.com', created_at: '2025-06-15T00:00:00Z', updated_at: '2026-03-28T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=charli&backgroundColor=ffd400',
    primary_platform: 'tiktok', secondary_platforms: ['instagram', 'youtube'],
    social_handles: { tiktok: 'charlidamelio', instagram: 'charlidamelio', youtube: 'charlidamelio' },
    follower_count: 155_600_000, engagement_rate: 0.0341,
    industry: 'dance & lifestyle', bio: 'Dancer, creator, and entrepreneur. Gen Z icon.',
    has_user: true, has_password: true, user_id: 1001, user_email: 'charli@damelio.com',
    gmv: 86_420, total_orders: 642,
  },
  {
    id: 2, first_name: 'Emma', last_name: 'Chamberlain', stage_name: 'Emma Chamberlain',
    influencer_id: 'emmachamberlain', slug: 'emmachamberlain', storefront_id: 102, status: 'active',
    email: 'emma@chamberlain.co', created_at: '2025-07-01T00:00:00Z', updated_at: '2026-03-20T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=emma&backgroundColor=4ade80',
    primary_platform: 'youtube', secondary_platforms: ['instagram', 'tiktok'],
    social_handles: { youtube: 'emmachamberlain', instagram: 'emmachamberlain', tiktok: 'emmachamberlain' },
    follower_count: 12_200_000, engagement_rate: 0.0528,
    industry: 'fashion & coffee', bio: 'YouTuber, podcaster, coffee brand founder.',
    has_user: true, has_password: true, user_id: 1002, user_email: 'emma@chamberlain.co',
    gmv: 64_310, total_orders: 478,
  },
  {
    id: 3, first_name: 'Bretman', last_name: 'Rock', stage_name: 'Bretman Rock',
    influencer_id: 'bretmanrock', slug: 'bretmanrock', storefront_id: 103, status: 'active',
    email: 'bretman@rock.com', created_at: '2025-07-18T00:00:00Z', updated_at: '2026-03-15T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=bretman&backgroundColor=a78bfa',
    primary_platform: 'instagram', secondary_platforms: ['tiktok', 'youtube'],
    social_handles: { instagram: 'bretmanrock', tiktok: 'bretmanrock', youtube: 'bretmanrock' },
    follower_count: 18_400_000, engagement_rate: 0.0412,
    industry: 'beauty & comedy', bio: 'Beauty guru, reality star, jungle king.',
    has_user: true, has_password: true, user_id: 1003, user_email: 'bretman@rock.com',
    gmv: 52_180, total_orders: 389,
  },
  {
    id: 4, first_name: 'Alix', last_name: 'Earle', stage_name: 'Alix Earle',
    influencer_id: 'alixearle', slug: 'alixearle', storefront_id: 104, status: 'active',
    email: 'alix@earle.co', created_at: '2025-08-05T00:00:00Z', updated_at: '2026-03-22T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=alix&backgroundColor=38bdf8',
    primary_platform: 'tiktok', secondary_platforms: ['instagram'],
    social_handles: { tiktok: 'alixearle', instagram: 'alixearle' },
    follower_count: 7_100_000, engagement_rate: 0.0687,
    industry: 'beauty & lifestyle', bio: 'Get ready with me queen. Brand deals and good vibes.',
    has_user: true, has_password: true, user_id: 1004, user_email: 'alix@earle.co',
    gmv: 47_890, total_orders: 356,
  },
  {
    id: 5, first_name: 'Wisdom', last_name: 'Kaye', stage_name: 'Wisdom Kaye',
    influencer_id: 'wisdm', slug: 'wisdm', storefront_id: 105, status: 'active',
    email: 'wisdom@kaye.co', created_at: '2025-08-20T00:00:00Z', updated_at: '2026-03-25T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=wisdom&backgroundColor=fbbf24',
    primary_platform: 'tiktok', secondary_platforms: ['instagram'],
    social_handles: { tiktok: 'wisdm', instagram: 'wfrancis' },
    follower_count: 9_800_000, engagement_rate: 0.0456,
    industry: 'fashion & menswear', bio: "TikTok's best-dressed man. Signed model.",
    has_user: true, has_password: true, user_id: 1005, user_email: 'wisdom@kaye.co',
    gmv: 41_760, total_orders: 310,
  },
  {
    id: 6, first_name: 'Tabitha', last_name: 'Brown', stage_name: 'Tabitha Brown',
    influencer_id: 'tabithabrown', slug: 'tabithabrown', storefront_id: 106, status: 'active',
    email: 'tab@tabithabrown.com', created_at: '2025-09-01T00:00:00Z', updated_at: '2026-03-18T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=tabitha&backgroundColor=4ade80',
    primary_platform: 'instagram', secondary_platforms: ['tiktok', 'youtube'],
    social_handles: { instagram: 'iamtabithabrown', tiktok: 'iamtabithabrown', youtube: 'tabithabrown' },
    follower_count: 5_200_000, engagement_rate: 0.0734,
    industry: 'food & wellness', bio: 'Vegan chef, actress, motivational speaker. That\'s your business.',
    has_user: true, has_password: true, user_id: 1006, user_email: 'tab@tabithabrown.com',
    gmv: 38_950, total_orders: 289,
  },
  {
    id: 7, first_name: 'Chris', last_name: 'Heria', stage_name: 'Chris Heria',
    influencer_id: 'chrisheria', slug: 'chrisheria', storefront_id: 107, status: 'active',
    email: 'chris@heria.com', created_at: '2025-09-12T00:00:00Z', updated_at: '2026-03-20T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=chris&backgroundColor=f87171',
    primary_platform: 'youtube', secondary_platforms: ['instagram', 'tiktok'],
    social_handles: { youtube: 'chrisheria', instagram: 'chrisheria', tiktok: 'chrisheria' },
    follower_count: 4_800_000, engagement_rate: 0.0389,
    industry: 'fitness & calisthenics', bio: 'Calisthenics athlete, THENX founder, music producer.',
    has_user: true, has_password: true, user_id: 1007, user_email: 'chris@heria.com',
    gmv: 33_420, total_orders: 248,
  },
  {
    id: 8, first_name: 'Tinx', last_name: '', stage_name: 'Tinx',
    influencer_id: 'tinx', slug: 'tinx', storefront_id: 108, status: 'active',
    email: 'team@tinx.co', created_at: '2025-10-01T00:00:00Z', updated_at: '2026-03-15T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=tinx&backgroundColor=fb923c',
    primary_platform: 'tiktok', secondary_platforms: ['instagram'],
    social_handles: { tiktok: 'tinx', instagram: 'tinx' },
    follower_count: 1_800_000, engagement_rate: 0.0521,
    industry: 'lifestyle & dating', bio: "TikTok's big sister. Lifestyle, dating, and rich mom starter packs.",
    has_user: true, has_password: true, user_id: 1008, user_email: 'team@tinx.co',
    gmv: 28_640, total_orders: 213,
  },
  {
    id: 9, first_name: 'Zach', last_name: 'King', stage_name: 'Zach King',
    influencer_id: 'zachking', slug: 'zachking', storefront_id: 109, status: 'active',
    email: 'zach@zachkingmagic.com', created_at: '2025-10-15T00:00:00Z', updated_at: '2026-03-10T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=zach&backgroundColor=a78bfa',
    primary_platform: 'tiktok', secondary_platforms: ['youtube', 'instagram'],
    social_handles: { tiktok: 'zachking', youtube: 'zachking', instagram: 'zachking' },
    follower_count: 81_000_000, engagement_rate: 0.0298,
    industry: 'magic & entertainment', bio: 'Digital magician. Filmmaker. #1 most followed creator on TikTok.',
    has_user: true, has_password: false, user_id: 1009, user_email: 'zach@zachkingmagic.com',
    gmv: 22_180, total_orders: 165,
  },
  {
    id: 10, first_name: 'Jackie', last_name: 'Aina', stage_name: 'Jackie Aina',
    influencer_id: 'jackieaina', slug: 'jackieaina', storefront_id: 110, status: 'active',
    email: 'jackie@aina.co', created_at: '2025-11-01T00:00:00Z', updated_at: '2026-03-08T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=jackie&backgroundColor=ffd400',
    primary_platform: 'youtube', secondary_platforms: ['instagram', 'tiktok'],
    social_handles: { youtube: 'jackieaina', instagram: 'jackieaina', tiktok: 'jackieaina' },
    follower_count: 3_600_000, engagement_rate: 0.0445,
    industry: 'beauty & skincare', bio: 'Beauty YouTuber, FORVR Mood founder, inclusivity advocate.',
    has_user: true, has_password: true, user_id: 1010, user_email: 'jackie@aina.co',
    gmv: 19_870, total_orders: 148,
  },
  {
    id: 11, first_name: 'Kara', last_name: 'Cooney', stage_name: 'Kara and Nate',
    influencer_id: 'karaandnate', slug: 'karaandnate', storefront_id: 111, status: 'active',
    email: 'team@karaandnate.com', created_at: '2025-11-10T00:00:00Z', updated_at: '2026-03-05T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=karanate&backgroundColor=38bdf8',
    primary_platform: 'youtube', secondary_platforms: ['instagram'],
    social_handles: { youtube: 'karaandnate', instagram: 'karaandnate' },
    follower_count: 4_100_000, engagement_rate: 0.0372,
    industry: 'travel & adventure', bio: 'Full-time travel couple. 100 countries and counting.',
    has_user: true, has_password: true, user_id: 1011, user_email: 'team@karaandnate.com',
    gmv: 16_540, total_orders: 123,
  },
  {
    id: 12, first_name: 'Mark', last_name: 'Wiens', stage_name: 'Mark Wiens',
    influencer_id: 'markwiens', slug: 'markwiens', storefront_id: 112, status: 'active',
    email: 'mark@migrationology.com', created_at: '2025-12-01T00:00:00Z', updated_at: '2026-03-01T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=markw&backgroundColor=4ade80',
    primary_platform: 'youtube', secondary_platforms: ['instagram', 'tiktok'],
    social_handles: { youtube: 'markwiens', instagram: 'markwiens', tiktok: 'markwiens' },
    follower_count: 10_500_000, engagement_rate: 0.0318,
    industry: 'food & travel', bio: 'Street food explorer. Travel filmmaker. Based in Bangkok.',
    has_user: true, has_password: true, user_id: 1012, user_email: 'mark@migrationology.com',
    gmv: 14_280, total_orders: 106,
  },
  {
    id: 13, first_name: 'Whitney', last_name: 'Simmons', stage_name: 'Whitney Simmons',
    influencer_id: 'whitneysimmons', slug: 'whitneysimmons', storefront_id: 113, status: 'active',
    email: 'whitney@alive.fit', created_at: '2025-12-15T00:00:00Z', updated_at: '2026-02-28T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=whitney&backgroundColor=fb923c',
    primary_platform: 'youtube', secondary_platforms: ['instagram', 'tiktok'],
    social_handles: { youtube: 'whitneysimmons', instagram: 'whitneysimmons', tiktok: 'whitneysimmons' },
    follower_count: 3_200_000, engagement_rate: 0.0489,
    industry: 'fitness & activewear', bio: 'Fitness YouTuber, Alive activewear founder.',
    has_user: true, has_password: true, user_id: 1013, user_email: 'whitney@alive.fit',
    gmv: 11_960, total_orders: 89,
  },
  {
    id: 14, first_name: 'Dude', last_name: 'Perfect', stage_name: 'Dude Perfect',
    influencer_id: 'dudeperfect', slug: 'dudeperfect', storefront_id: 114, status: 'active',
    email: 'team@dudeperfect.com', created_at: '2026-01-05T00:00:00Z', updated_at: '2026-02-25T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=dude&backgroundColor=a78bfa',
    primary_platform: 'youtube', secondary_platforms: ['instagram', 'tiktok'],
    social_handles: { youtube: 'dudeperfect', instagram: 'dudeperfect', tiktok: 'dudeperfect' },
    follower_count: 60_300_000, engagement_rate: 0.0275,
    industry: 'sports & entertainment', bio: 'Trick shots, comedy, and sports. Five best friends from Texas.',
    has_user: true, has_password: false, user_id: 1014, user_email: 'team@dudeperfect.com',
    gmv: 9_840, total_orders: 73,
  },
  {
    id: 15, first_name: 'Nyma', last_name: 'Tang', stage_name: 'Nyma Tang',
    influencer_id: 'nymatang', slug: 'nymatang', storefront_id: 115, status: 'active',
    email: 'nyma@tang.co', created_at: '2026-01-20T00:00:00Z', updated_at: '2026-02-20T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=nyma&backgroundColor=ffd400',
    primary_platform: 'youtube', secondary_platforms: ['instagram'],
    social_handles: { youtube: 'nymatang', instagram: 'nymatang' },
    follower_count: 1_500_000, engagement_rate: 0.0563,
    industry: 'beauty & inclusivity', bio: 'The Darkest Shade series. Beauty equity advocate.',
    has_user: false, has_password: false, user_id: null, user_email: null,
    gmv: 7_210, total_orders: 54,
  },
  {
    id: 16, first_name: 'Mat', last_name: 'Zucker', stage_name: 'Matty Matheson',
    influencer_id: 'mattymatheson', slug: 'mattymatheson', storefront_id: 116, status: 'inactive',
    email: 'matt@mattymatheson.com', created_at: '2026-02-01T00:00:00Z', updated_at: '2026-03-01T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=matty&backgroundColor=f87171',
    primary_platform: 'instagram', secondary_platforms: ['youtube', 'tiktok'],
    social_handles: { instagram: 'mattymatheson', youtube: 'mattymatheson', tiktok: 'mattymatheson' },
    follower_count: 3_900_000, engagement_rate: 0.0401,
    industry: 'food & culinary', bio: 'Chef, TV personality, The Bear actor. Matty Matheson cookware.',
    has_user: true, has_password: true, user_id: 1016, user_email: 'matt@mattymatheson.com',
    gmv: 4_530, total_orders: 34,
  },
  {
    id: 17, first_name: 'Safiya', last_name: 'Nygaard', stage_name: 'Safiya Nygaard',
    influencer_id: 'safiyanygaard', slug: 'safiyanygaard', storefront_id: 117, status: 'active',
    email: 'saf@safiyanygaard.com', created_at: '2026-02-15T00:00:00Z', updated_at: '2026-03-12T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=safiya&backgroundColor=38bdf8',
    primary_platform: 'youtube', secondary_platforms: ['instagram', 'tiktok'],
    social_handles: { youtube: 'safiyanygaard', instagram: 'safiyany', tiktok: 'safiyany' },
    follower_count: 9_900_000, engagement_rate: 0.0356,
    industry: 'fashion & experiments', bio: 'Mixing every lipstick in the world. Fashion science experiments.',
    has_user: false, has_password: false, user_id: null, user_email: null,
    gmv: 3_120, total_orders: 23,
  },
  {
    id: 18, first_name: 'Jay', last_name: 'Shetty', stage_name: 'Jay Shetty',
    influencer_id: 'jayshetty', slug: 'jayshetty', storefront_id: 118, status: 'active',
    email: 'jay@jayshetty.me', created_at: '2026-03-01T00:00:00Z', updated_at: '2026-03-28T00:00:00Z',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=jay&backgroundColor=fbbf24',
    primary_platform: 'instagram', secondary_platforms: ['youtube', 'tiktok'],
    social_handles: { instagram: 'jayshetty', youtube: 'jayshetty', tiktok: 'jayshetty' },
    follower_count: 14_800_000, engagement_rate: 0.0312,
    industry: 'mindfulness & wellness', bio: 'Former monk, purpose coach, bestselling author, podcast host.',
    has_user: false, has_password: false, user_id: null, user_email: null,
    gmv: 1_480, total_orders: 11,
  },
];

// Keep backward-compatible alias
export const DEMO_INFLUENCERS = DEMO_INFLUENCERS_ENRICHED;

// ── Influencer Dashboard ──────────────────────────────────────────────────

export const DEMO_INFLUENCER_METRICS = {
  totalRevenue: 41_280,
  totalOrders: 312,
  avgOrderValue: 132.31,
  totalCustomers: 289,
  revenueChange: 18.4,
  ordersChange: 12.7,
};

export const DEMO_INFLUENCER_REVENUE_BY_DAY = (() => {
  const days: Array<{ date: string; revenue: number; orders: number }> = [];
  const base = Date.now() - 29 * 86400000;
  for (let i = 0; i < 30; i++) {
    const d = new Date(base + i * 86400000);
    const rev = 1100 + Math.sin(i * 0.8) * 400 + Math.random() * 300;
    days.push({
      date: d.toISOString().slice(0, 10),
      revenue: Math.round(rev),
      orders: Math.round(rev / 132),
    });
  }
  return days;
})();

export const DEMO_INFLUENCER_TOP_PRODUCTS = [
  { shopify_product_id: 'sp001', title: 'Recycled Denim Crossbody Bag', total_units: 94, total_revenue: 4_136, currency: 'USD' },
  { shopify_product_id: 'sp002', title: 'Organic Cotton Oversized Tee', total_units: 78, total_revenue: 2_496, currency: 'USD' },
  { shopify_product_id: 'sp003', title: 'Minimalist Gold Huggie Earrings', total_units: 65, total_revenue: 1_430, currency: 'USD' },
  { shopify_product_id: 'sp004', title: 'Premium Bamboo Tote Bag', total_units: 52, total_revenue: 1_612, currency: 'USD' },
  { shopify_product_id: 'sp005', title: 'Ceramic Tumbler Set × 2', total_units: 38, total_revenue: 1_748, currency: 'USD' },
];

export const DEMO_INFLUENCER_ORDERS = Array.from({ length: 12 }, (_, i) => ({
  id: 10000 + i,
  shopify_order_id: String(45000 + i),
  order_number: `#${1001 + i}`,
  created_at: new Date(Date.now() - i * 2.5 * 86400000).toISOString(),
  status: ['paid', 'fulfilled', 'paid', 'fulfilled', 'fulfilled', 'paid', 'refunded', 'fulfilled', 'paid', 'fulfilled', 'paid', 'cancelled'][i],
  total_price: (89 + i * 17.5).toFixed(2),
  customer_name: ['Emma Wilson', 'James Carter', 'Olivia Brown', 'Liam Davis', 'Ava Miller', 'Noah Johnson', 'Isabella Martinez', 'William Anderson', 'Mia Thomas', 'James Jackson', 'Charlotte White', 'Benjamin Harris'][i],
  line_items_count: 1 + (i % 3),
}));

// ── Vendor Dashboard ──────────────────────────────────────────────────────

export const DEMO_VENDOR_DASHBOARD = {
  total_products: 24,
  pending_orders: 8,
  total_gmv: 63_450,
  total_sales: 58_200,
  fulfillment_rate: 94.2,
  low_stock_count: 3,
  orders_by_status: {
    new: 4,
    processing: 4,
    shipped: 12,
    delivered: 38,
    exception: 1,
    cancelled: 2,
  },
  top_products: [
    { title: 'Premium Bamboo Tote Bag',     units: 284, revenue: 9_944 },
    { title: 'Organic Cotton Hoodie — Oat', units: 211, revenue: 11_605 },
    { title: 'Minimalist Phone Stand (Blk)',units: 196, revenue: 4_900 },
    { title: 'Recycled Denim Crossbody',    units: 158, revenue: 8_690 },
    { title: 'Ceramic Tumbler Set × 2',     units: 144, revenue: 7_488 },
  ],
  recent_orders: [
    { id: 2001, order_number: '#20001', status: 'new',        total_amount: '148.00', created_at: new Date(Date.now() - 2  * 3600000).toISOString() },
    { id: 2002, order_number: '#20002', status: 'processing', total_amount: '76.50',  created_at: new Date(Date.now() - 5  * 3600000).toISOString() },
    { id: 2003, order_number: '#20003', status: 'shipped',    total_amount: '214.00', created_at: new Date(Date.now() - 18 * 3600000).toISOString() },
    { id: 2004, order_number: '#20004', status: 'delivered',  total_amount: '89.99',  created_at: new Date(Date.now() - 2  * 86400000).toISOString() },
    { id: 2005, order_number: '#20005', status: 'new',        total_amount: '55.00',  created_at: new Date(Date.now() - 3  * 3600000).toISOString() },
  ],
  revenue_by_day: (() => {
    const out: Array<{ date: string; revenue: number; orders: number }> = [];
    const base = Date.now() - 29 * 86400000;
    for (let i = 0; i < 30; i++) {
      const d = new Date(base + i * 86400000);
      const rev = 1800 + Math.sin(i * 0.7) * 600 + Math.random() * 400;
      out.push({ date: d.toISOString().slice(0, 10), revenue: Math.round(rev), orders: Math.round(rev / 82) });
    }
    return out;
  })(),
  top_influencers: [
    {
      influencer_id: 'sophiachen',
      slug: 'sophiachen',
      stage_name: 'Sophia Chen',
      platform: 'tiktok',
      category: 'fashion',
      follower_count: 284_000,
      engagement_rate: 0.0522,
      profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=sophia&backgroundColor=ffd400',
      orders: 84,
      revenue: 12_432,
      forecast_gmv: 45_000,
      approved: true,
    },
    {
      influencer_id: 'marcuslee',
      slug: 'marcuslee',
      stage_name: 'Marcus Lee',
      platform: 'instagram',
      category: 'fitness',
      follower_count: 193_000,
      engagement_rate: 0.0418,
      profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=marcus&backgroundColor=4ade80',
      orders: 71,
      revenue: 9_867,
      forecast_gmv: 32_000,
      approved: true,
    },
    {
      influencer_id: 'aishapatel',
      slug: 'aishapatel',
      stage_name: 'Aisha Patel',
      platform: 'tiktok',
      category: 'beauty',
      follower_count: 156_000,
      engagement_rate: 0.0631,
      profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=aisha&backgroundColor=a78bfa',
      orders: 58,
      revenue: 7_540,
      forecast_gmv: 28_500,
      approved: false,
    },
    {
      influencer_id: 'lunapark',
      slug: 'lunapark',
      stage_name: 'Luna Park',
      platform: 'youtube',
      category: 'lifestyle',
      follower_count: 97_000,
      engagement_rate: 0.0389,
      profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=luna&backgroundColor=38bdf8',
      orders: 44,
      revenue: 5_896,
      forecast_gmv: 18_000,
      approved: false,
    },
    {
      influencer_id: 'jakemoreno',
      slug: 'jakemoreno',
      stage_name: 'Jake Moreno',
      platform: 'youtube',
      category: 'tech',
      follower_count: 412_000,
      engagement_rate: 0.0345,
      profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=jake&backgroundColor=fb923c',
      orders: 32,
      revenue: 4_120,
      forecast_gmv: 22_000,
      approved: false,
    },
    {
      influencer_id: 'ninakim',
      slug: 'ninakim',
      stage_name: 'Nina Kim',
      platform: 'instagram',
      category: 'beauty',
      follower_count: 320_000,
      engagement_rate: 0.0578,
      profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=nina&backgroundColor=f472b6',
      orders: 0,
      revenue: 0,
      forecast_gmv: 38_000,
      approved: false,
    },
    {
      influencer_id: 'devonwilliams',
      slug: 'devonwilliams',
      stage_name: 'Devon Williams',
      platform: 'tiktok',
      category: 'fitness',
      follower_count: 540_000,
      engagement_rate: 0.0482,
      profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=devon&backgroundColor=38bdf8',
      orders: 0,
      revenue: 0,
      forecast_gmv: 52_000,
      approved: false,
    },
    {
      influencer_id: 'emilyzhu',
      slug: 'emilyzhu',
      stage_name: 'Emily Zhu',
      platform: 'tiktok',
      category: 'fashion',
      follower_count: 178_000,
      engagement_rate: 0.0612,
      profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=emily&backgroundColor=a78bfa',
      orders: 0,
      revenue: 0,
      forecast_gmv: 24_000,
      approved: false,
    },
  ],
  restock_needed: [
    // alert_message intentionally null so the UI uses the translated t('vendor:dashboard.minOrder') fallback
    { id: 'p4', title: 'Recycled Denim Crossbody', moq: 15, has_alert: true,  alert_message: null },
    { id: 'p5', title: 'Ceramic Tumbler Set × 2',  moq: 12, has_alert: true,  alert_message: null },
    { id: 'p1', title: 'Premium Bamboo Tote Bag',  moq: 20, has_alert: false, alert_message: null },
  ],
  monthly_forecast: 68_000,
  annual_forecast: 742_000,
  next_payout_amount: 8_420.50,
  next_payout_date: (() => {
    const d = new Date();
    d.setDate(15);
    if (d < new Date()) d.setMonth(d.getMonth() + 1);
    return d.toISOString().slice(0, 10);
  })(),
  trending_products: [
    {
      name: 'Biodegradable Phone Case — Kraft',
      category: 'accessories',
      target_ddp: 4.80,
      market_price: 24.99,
      supplier: 'Shenzhen GreenTech Co.',
      image_url: 'https://api.dicebear.com/8.x/shapes/svg?seed=phonecase&backgroundColor=1a1a1a',
      trend_pct: 18,
    },
    {
      name: 'Magnetic Wireless Charger Pad',
      category: 'tech',
      target_ddp: 6.20,
      market_price: 34.99,
      supplier: 'Dongguan PowerLink Ltd.',
      image_url: 'https://api.dicebear.com/8.x/shapes/svg?seed=charger&backgroundColor=1a1a1a',
      trend_pct: 24,
    },
    {
      name: 'Insulated Stainless Tumbler 30oz',
      category: 'drinkware',
      target_ddp: 5.50,
      market_price: 29.99,
      supplier: 'Yongkang HydroMate',
      image_url: 'https://api.dicebear.com/8.x/shapes/svg?seed=tumbler&backgroundColor=1a1a1a',
      trend_pct: 12,
    },
  ],
};

export const DEMO_VENDOR_PRODUCTS = [
  { id: 'p1', title: 'Premium Bamboo Tote Bag',     category: 'accessories', price_min: 28, price_max: 35,  status: 'active',   moq: 20,  is_test: false, shopify_product_id: 'sp001', shopify_status: 'active',  created_at: '2026-01-10', updated_at: '2026-03-15' },
  { id: 'p2', title: 'Organic Cotton Hoodie — Oat', category: 'apparel',     price_min: 42, price_max: 55,  status: 'active',   moq: 10,  is_test: false, shopify_product_id: 'sp002', shopify_status: 'active',  created_at: '2026-01-18', updated_at: '2026-03-20' },
  { id: 'p3', title: 'Minimalist Phone Stand (Blk)',category: 'accessories', price_min: 18, price_max: 25,  status: 'active',   moq: 50,  is_test: false, shopify_product_id: 'sp003', shopify_status: 'active',  created_at: '2026-02-01', updated_at: '2026-03-22' },
  { id: 'p4', title: 'Recycled Denim Crossbody',    category: 'accessories', price_min: 45, price_max: 55,  status: 'active',   moq: 15,  is_test: false, shopify_product_id: 'sp004', shopify_status: 'active',  created_at: '2026-02-10', updated_at: '2026-03-25' },
  { id: 'p5', title: 'Ceramic Tumbler Set × 2',     category: 'home',        price_min: 38, price_max: 52,  status: 'active',   moq: 12,  is_test: false, shopify_product_id: 'sp005', shopify_status: 'active',  created_at: '2026-02-15', updated_at: '2026-03-28' },
  { id: 'p6', title: 'Canvas Belt Bag — Sand',      category: 'accessories', price_min: 24, price_max: 32,  status: 'pending_review', moq: 25, is_test: false, shopify_product_id: null, shopify_status: null, created_at: '2026-03-28', updated_at: '2026-03-28' },
  { id: 'p7', title: 'Eco Candle — Cedar & Sage',   category: 'home',        price_min: 16, price_max: 22,  status: 'draft',    moq: 30,  is_test: false, shopify_product_id: null, shopify_status: null, created_at: '2026-03-30', updated_at: '2026-03-30' },
  { id: 'p8', title: '[TEST] Sample Bundle v2',     category: 'general',     price_min: 10, price_max: 10,  status: 'draft',    moq: 1,   is_test: true,  shopify_product_id: null, shopify_status: null, created_at: '2026-03-31', updated_at: '2026-03-31' },
];

export const DEMO_VENDOR_ORDERS = Array.from({ length: 10 }, (_, i) => ({
  id: 2001 + i,
  shopify_order_id: String(90000 + i),
  status: ['new', 'processing', 'shipped', 'delivered', 'new', 'processing', 'shipped', 'delivered', 'exception', 'cancelled'][i],
  fulfillment_deadline: i < 4 ? new Date(Date.now() + (2 + i) * 86400000).toISOString() : null,
  total_amount: (65 + i * 22.5).toFixed(2),
  line_items: [{ title: 'Product', quantity: 1 + (i % 2), price: 65 + i * 22.5 }],
  internal_notes: null,
  created_at: new Date(Date.now() - i * 1.8 * 86400000).toISOString(),
  updated_at: new Date(Date.now() - i * 0.5 * 86400000).toISOString(),
}));

export const DEMO_VENDOR_ANALYTICS = {
  sales: {
    series: (() => {
      const out: Array<{ date: string; revenue: number; count: number }> = [];
      const base = Date.now() - 29 * 86400000;
      for (let i = 0; i < 30; i++) {
        const d = new Date(base + i * 86400000);
        const rev = 1800 + Math.sin(i * 0.7) * 500 + Math.random() * 400;
        out.push({ date: d.toISOString().slice(0, 10), revenue: Math.round(rev), count: Math.round(rev / 78) });
      }
      return out;
    })(),
    total_revenue: 58_200,
    total_orders: 746,
    avg_order_value: 78.01,
  },
  products: DEMO_VENDOR_PRODUCTS.slice(0, 5).map((p, i) => ({
    title: p.title,
    units: [284, 211, 196, 158, 144][i],
    revenue: [9944, 11605, 4900, 8690, 7488][i],
    orders: [284, 211, 196, 158, 144][i],
  })),
  fulfillment: {
    total_orders: 746,
    shipped: 702,
    fulfillment_rate: 94.2,
    exception_rate: 1.8,
    avg_ship_days: 2.4,
  },
};

// ── Creator Match (demo run result) ──────────────────────────────────────

export const DEMO_MATCH_RESULT = {
  creator: {
    id: 99,
    platform: 'tiktok' as const,
    handle: 'sophiachen',
    profile_url: 'https://www.tiktok.com/@sophiachen',
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=sophia&backgroundColor=ffd400',
  },
  analysis: {
    id: 999,
    followers: 284_000,
    avg_views: 48_200,
    avg_likes: 9_600,
    engagement_rate: 0.0522,
    audience_age_min: 18,
    audience_age_max: 34,
    audience_gender_affinity: 'female',
    primary_category: 'fashion',
    secondary_categories: ['beauty', 'lifestyle'],
    geo_top_countries: [
      { country: 'US', pct: 0.42 },
      { country: 'UK', pct: 0.18 },
      { country: 'CA', pct: 0.12 },
      { country: 'AU', pct: 0.09 },
    ],
    gender_distribution: { female: 0.71, male: 0.29 },
    interests_ranked: [
      { label: 'Fashion & Style', followers_pct: 0.68 },
      { label: 'Beauty & Skincare', followers_pct: 0.54 },
      { label: 'Lifestyle', followers_pct: 0.41 },
      { label: 'Home Décor', followers_pct: 0.29 },
      { label: 'Travel', followers_pct: 0.22 },
    ],
    brand_affinity_ranked: [
      { label: 'Zara', followers_pct: 0.38 },
      { label: 'ASOS', followers_pct: 0.31 },
      { label: 'Nike', followers_pct: 0.27 },
      { label: 'Glossier', followers_pct: 0.24 },
    ],
    collaboration_brands: [
      { name: 'Revolve', category: 'FASHION_APPAREL', type: 'SPONSORED_POST' as const },
      { name: 'Sephora', category: 'BEAUTY', type: 'AFFILIATE' as const },
    ],
    provider: 'modash',
    is_mock: false,
    fetched_at: new Date(Date.now() - 2 * 3600000).toISOString(),
  },
  match_run_id: 9999,
  top_products: [
    {
      rank: 1, product_id: 1001, title: 'Recycled Denim Crossbody Bag',
      short_description: 'Sustainable denim bag, handmade from upcycled materials.',
      primary_image_url: null, vertical: 'accessories', category: 'bags',
      price_min: 45, price_max: 58, currency: 'USD',
      tags: ['fashion', 'sustainable', 'accessories', 'bag'],
      score: 0.847, score_pct: 85, gmv_low: 28_400, gmv_expected: 47_200, gmv_high: 68_900,
      factor_breakdown: { category: { weight: 0.25, raw_score: 0.9, contribution: 0.225, why: 'Strong fashion/accessories vertical match' }, tags: { weight: 0.38, raw_score: 0.85, contribution: 0.323, why: '3 direct tag overlaps (fashion, sustainable, accessories)' }, age: { weight: 0.1, raw_score: 0.82, contribution: 0.082, why: '18–34 audience aligns with product market' }, price: { weight: 0.1, raw_score: 0.75, contribution: 0.075, why: 'Price point fits audience spend' }, margin: { weight: 0.03, raw_score: 0.7, contribution: 0.021, why: 'Above average margin' }, complexity: { weight: 0.05, raw_score: 0.85, contribution: 0.0425, why: 'Low fulfilment complexity' }, proof: { weight: 0.02, raw_score: 0.9, contribution: 0.018, why: 'Strong social proof' }, interest_affinity: { weight: 0.12, raw_score: 0.88, contribution: 0.1056, why: 'High audience interest alignment' }, gender_penalty: { weight: 0, raw_score: 0, contribution: 0, why: 'No penalty' }, total_score: 0.847 },
    },
    {
      rank: 2, product_id: 1002, title: 'Organic Cotton Oversized Tee',
      short_description: 'Soft-washed 100% organic cotton, gender-neutral sizing.',
      primary_image_url: null, vertical: 'apparel', category: 'tops',
      price_min: 28, price_max: 38, currency: 'USD',
      tags: ['fashion', 'organic', 'apparel', 'casual'],
      score: 0.801, score_pct: 80, gmv_low: 23_100, gmv_expected: 38_400, gmv_high: 56_200,
      factor_breakdown: { category: { weight: 0.25, raw_score: 0.88, contribution: 0.22, why: 'Apparel/fashion category match' }, tags: { weight: 0.38, raw_score: 0.79, contribution: 0.300, why: '2 direct + 1 alias tag overlaps' }, age: { weight: 0.1, raw_score: 0.8, contribution: 0.08, why: 'Good age fit' }, price: { weight: 0.1, raw_score: 0.82, contribution: 0.082, why: 'Affordable, impulse-friendly' }, margin: { weight: 0.03, raw_score: 0.65, contribution: 0.0195, why: 'Average margin' }, complexity: { weight: 0.05, raw_score: 0.9, contribution: 0.045, why: 'Very simple product' }, proof: { weight: 0.02, raw_score: 0.8, contribution: 0.016, why: 'Good reviews' }, interest_affinity: { weight: 0.12, raw_score: 0.82, contribution: 0.0984, why: 'Fashion + lifestyle interest match' }, gender_penalty: { weight: 0, raw_score: 0, contribution: 0, why: 'No penalty' }, total_score: 0.801 },
    },
    {
      rank: 3, product_id: 1003, title: 'Minimalist Gold Huggie Earrings',
      short_description: '18k gold-plated stainless steel, hypoallergenic.',
      primary_image_url: null, vertical: 'accessories', category: 'jewelry',
      price_min: 18, price_max: 26, currency: 'USD',
      tags: ['jewelry', 'gold', 'minimal', 'beauty'],
      score: 0.774, score_pct: 77, gmv_low: 19_800, gmv_expected: 33_000, gmv_high: 48_500,
      factor_breakdown: { category: { weight: 0.25, raw_score: 0.85, contribution: 0.2125, why: 'Accessories/jewelry affinity' }, tags: { weight: 0.38, raw_score: 0.76, contribution: 0.2888, why: '2 tag overlaps' }, age: { weight: 0.1, raw_score: 0.79, contribution: 0.079, why: 'Age appropriate' }, price: { weight: 0.1, raw_score: 0.88, contribution: 0.088, why: 'Low price = impulse buy' }, margin: { weight: 0.03, raw_score: 0.78, contribution: 0.0234, why: 'High margin jewelry' }, complexity: { weight: 0.05, raw_score: 0.95, contribution: 0.0475, why: 'Very easy to ship' }, proof: { weight: 0.02, raw_score: 0.85, contribution: 0.017, why: 'Viral potential' }, interest_affinity: { weight: 0.12, raw_score: 0.77, contribution: 0.0924, why: 'Beauty audience cross-interest' }, gender_penalty: { weight: 0, raw_score: 0, contribution: 0, why: 'No penalty' }, total_score: 0.774 },
    },
  ],
  gmv: {
    gmv_low: 71_300, gmv_expected: 118_600, gmv_high: 173_600,
    buyers_low: 1_698, buyers_expected: 2_824, buyers_high: 4_133,
    tier: 1, confidence: 0.78,
    aov_estimated: 42,
    assumptions: { platform: 'tiktok', follower_tier: '100k-500k', engagement_tier: 'high', geo_bias: 'us_heavy', scoring_config: 'default' },
  },
  is_mock: false,
};

// ── Singleton access ──────────────────────────────────────────────────────

export type DemoData = typeof DEMO_ADMIN_DASHBOARD & { _loaded: true };

// ── Explore Influencers page (spreadsheet view) ───────────────────────────

export const DEMO_RUN_RESULTS = [
  { rank: 1, score: 0.872, products: { id: 2001, title: 'Silk Effect Hair Serum', primary_image_url: null, price_min: 22, price_max: 32, vertical: 'beauty', category: 'hair care', tags: ['beauty', 'hair', 'serum', 'silky'] }, factor_breakdown: { category: { weight: 0.25, raw_score: 0.9, contribution: 0.225, why: 'Beauty/hair care match' }, tags: { weight: 0.38, raw_score: 0.92, contribution: 0.3496, why: '4 direct tag overlaps' }, age: { weight: 0.1, raw_score: 0.82, contribution: 0.082, why: 'Good age fit' }, price: { weight: 0.1, raw_score: 0.86, contribution: 0.086, why: 'Affordable impulse buy' }, margin: { weight: 0.03, raw_score: 0.7, contribution: 0.021, why: 'Good margin' }, complexity: { weight: 0.05, raw_score: 0.88, contribution: 0.044, why: 'Easy to ship' }, proof: { weight: 0.02, raw_score: 0.9, contribution: 0.018, why: 'High review count' }, interest_affinity: { weight: 0.12, raw_score: 0.88, contribution: 0.1056, why: 'Strong beauty interest' }, gender_penalty: { weight: 0, raw_score: 0, contribution: 0, why: '' }, total_score: 0.872 } },
  { rank: 2, score: 0.831, products: { id: 2002, title: 'Rose Quartz Gua Sha + Roller Set', primary_image_url: null, price_min: 18, price_max: 28, vertical: 'beauty', category: 'skincare tools', tags: ['beauty', 'skincare', 'rose quartz', 'wellness'] }, factor_breakdown: { category: { weight: 0.25, raw_score: 0.87, contribution: 0.2175, why: 'Skincare tool match' }, tags: { weight: 0.38, raw_score: 0.84, contribution: 0.3192, why: '3 direct tag overlaps' }, age: { weight: 0.1, raw_score: 0.8, contribution: 0.08, why: 'Young female audience' }, price: { weight: 0.1, raw_score: 0.88, contribution: 0.088, why: 'Low price' }, margin: { weight: 0.03, raw_score: 0.76, contribution: 0.0228, why: 'Decent margin' }, complexity: { weight: 0.05, raw_score: 0.92, contribution: 0.046, why: 'Very simple product' }, proof: { weight: 0.02, raw_score: 0.87, contribution: 0.0174, why: 'TikTok viral' }, interest_affinity: { weight: 0.12, raw_score: 0.84, contribution: 0.1008, why: 'Beauty/wellness cross-interest' }, gender_penalty: { weight: 0, raw_score: 0, contribution: 0, why: '' }, total_score: 0.831 } },
  { rank: 3, score: 0.796, products: { id: 2003, title: 'Minimalist Huggie Earrings Set (3pc)', primary_image_url: null, price_min: 16, price_max: 24, vertical: 'accessories', category: 'jewelry', tags: ['jewelry', 'minimal', 'gold', 'accessories'] }, factor_breakdown: { category: { weight: 0.25, raw_score: 0.82, contribution: 0.205, why: 'Accessories match' }, tags: { weight: 0.38, raw_score: 0.80, contribution: 0.304, why: '3 tag overlaps' }, age: { weight: 0.1, raw_score: 0.78, contribution: 0.078, why: 'Age appropriate' }, price: { weight: 0.1, raw_score: 0.90, contribution: 0.09, why: 'Very affordable' }, margin: { weight: 0.03, raw_score: 0.82, contribution: 0.0246, why: 'High margin jewelry' }, complexity: { weight: 0.05, raw_score: 0.96, contribution: 0.048, why: 'Easy to ship' }, proof: { weight: 0.02, raw_score: 0.82, contribution: 0.0164, why: 'Good reviews' }, interest_affinity: { weight: 0.12, raw_score: 0.77, contribution: 0.0924, why: 'Style audience' }, gender_penalty: { weight: 0, raw_score: 0, contribution: 0, why: '' }, total_score: 0.796 } },
  { rank: 4, score: 0.754, products: { id: 2004, title: 'Aesthetic Phone Case Assorted', primary_image_url: null, price_min: 8, price_max: 14, vertical: 'accessories', category: 'tech accessories', tags: ['accessories', 'aesthetic', 'phone', 'cute'] }, factor_breakdown: { category: { weight: 0.25, raw_score: 0.75, contribution: 0.1875, why: 'Gen-Z aesthetic match' }, tags: { weight: 0.38, raw_score: 0.78, contribution: 0.2964, why: '3 tag overlaps' }, age: { weight: 0.1, raw_score: 0.85, contribution: 0.085, why: 'Young audience' }, price: { weight: 0.1, raw_score: 0.96, contribution: 0.096, why: 'Very low price' }, margin: { weight: 0.03, raw_score: 0.6, contribution: 0.018, why: 'Lower margin' }, complexity: { weight: 0.05, raw_score: 0.94, contribution: 0.047, why: 'Easy to ship' }, proof: { weight: 0.02, raw_score: 0.75, contribution: 0.015, why: 'Moderate reviews' }, interest_affinity: { weight: 0.12, raw_score: 0.70, contribution: 0.084, why: 'Lifestyle interest' }, gender_penalty: { weight: 0, raw_score: 0, contribution: 0, why: '' }, total_score: 0.754 } },
  { rank: 5, score: 0.711, products: { id: 2005, title: 'Bamboo Satin Pillowcase Pair', primary_image_url: null, price_min: 24, price_max: 36, vertical: 'home', category: 'bedding', tags: ['home', 'satin', 'sleep', 'beauty'] }, factor_breakdown: { category: { weight: 0.25, raw_score: 0.72, contribution: 0.18, why: 'Home/beauty crossover' }, tags: { weight: 0.38, raw_score: 0.74, contribution: 0.2812, why: '2 tag overlaps' }, age: { weight: 0.1, raw_score: 0.75, contribution: 0.075, why: 'Moderate age fit' }, price: { weight: 0.1, raw_score: 0.82, contribution: 0.082, why: 'Reasonable price' }, margin: { weight: 0.03, raw_score: 0.68, contribution: 0.0204, why: 'Average margin' }, complexity: { weight: 0.05, raw_score: 0.88, contribution: 0.044, why: 'Easy to ship' }, proof: { weight: 0.02, raw_score: 0.78, contribution: 0.0156, why: 'Good social proof' }, interest_affinity: { weight: 0.12, raw_score: 0.69, contribution: 0.0828, why: 'Lifestyle crossover' }, gender_penalty: { weight: 0, raw_score: 0, contribution: 0, why: '' }, total_score: 0.711 } },
];

const makeInterests = (labels: string[]) =>
  labels.map((label, i) => ({ label, followers_pct: Math.max(0.1, 0.75 - i * 0.12) }));
const makeBrands = (labels: string[]) =>
  labels.map((label, i) => ({ label, followers_pct: Math.max(0.05, 0.55 - i * 0.1) }));

export const DEMO_EXPLORE_RUNS = [
  {
    id: 1001, created_at: '2025-03-22T14:30:00Z',
    gmv_low: 89_400, gmv_expected: 148_900, gmv_high: 218_100, tier: 1, confidence: 0.82,
    assumptions: { aov_estimated: 42, platform_details: [{ platform: 'tiktok', handle: '@sophiachen' }, { platform: 'instagram', handle: '@sophiachen' }], is_multi_platform: true, summary_text: 'Strong fashion/beauty creator with high female audience affinity.' },
    creator_analyses: {
      followers: 284_000, engagement_rate: 0.0522, avg_views: 48_200, primary_category: 'fashion',
      provider: 'modash', profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=sophia&backgroundColor=ffd400',
      audience_gender_affinity: 'female', audience_age_min: 18, audience_age_max: 34,
      geo_top_countries: [{ country: 'US', pct: 0.42 }, { country: 'UK', pct: 0.18 }],
      interests_ranked: makeInterests(['Fashion & Style', 'Beauty & Skincare', 'Lifestyle', 'Travel', 'Wellness']),
      brand_affinity_ranked: makeBrands(['Sephora', 'Zara', 'ASOS', 'Revolve', 'FashionNova']),
      derived_features: null,
      creators: { platform: 'tiktok', handle: '@sophiachen', profile_url: 'https://www.tiktok.com/@sophiachen' },
    },
  },
  {
    id: 1002, created_at: '2025-03-20T09:15:00Z',
    gmv_low: 34_200, gmv_expected: 57_000, gmv_high: 83_500, tier: 2, confidence: 0.71,
    assumptions: { aov_estimated: 38, platform_details: [{ platform: 'instagram', handle: '@marcusfit' }], is_multi_platform: false, summary_text: 'Fitness/wellness creator with engaged male audience.' },
    creator_analyses: {
      followers: 156_000, engagement_rate: 0.0418, avg_views: null, primary_category: 'fitness',
      provider: 'modash', profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=marcus&backgroundColor=0b0b0b',
      audience_gender_affinity: 'male', audience_age_min: 22, audience_age_max: 38,
      geo_top_countries: [{ country: 'US', pct: 0.55 }, { country: 'CA', pct: 0.14 }],
      interests_ranked: makeInterests(['Fitness & Health', 'Sports', 'Nutrition', 'Wellness', 'Outdoor Activities']),
      brand_affinity_ranked: makeBrands(['Nike', 'Under Armour', 'GNC', 'Gymshark', 'Optimum Nutrition']),
      derived_features: null,
      creators: { platform: 'instagram', handle: '@marcusfit', profile_url: 'https://www.instagram.com/marcusfit' },
    },
  },
  {
    id: 1003, created_at: '2025-03-18T16:45:00Z',
    gmv_low: 61_800, gmv_expected: 103_000, gmv_high: 150_800, tier: 1, confidence: 0.76,
    assumptions: { aov_estimated: 45, platform_details: [{ platform: 'youtube', handle: '@TechWithLila' }], is_multi_platform: false, summary_text: 'Tech & lifestyle YouTuber with strong purchase intent audience.' },
    creator_analyses: {
      followers: 412_000, engagement_rate: 0.0312, avg_views: 89_400, primary_category: 'technology',
      provider: 'modash', profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=lila&backgroundColor=1a1a2e',
      audience_gender_affinity: 'mixed', audience_age_min: 20, audience_age_max: 40,
      geo_top_countries: [{ country: 'US', pct: 0.38 }, { country: 'IN', pct: 0.22 }, { country: 'UK', pct: 0.12 }],
      interests_ranked: makeInterests(['Technology', 'Gadgets', 'Productivity', 'Gaming', 'Home Office']),
      brand_affinity_ranked: makeBrands(['Apple', 'Samsung', 'Anker', 'Logitech', 'Amazon']),
      derived_features: null,
      creators: { platform: 'youtube', handle: '@TechWithLila', profile_url: 'https://www.youtube.com/@TechWithLila' },
    },
  },
  {
    id: 1004, created_at: '2025-03-15T11:20:00Z',
    gmv_low: 18_600, gmv_expected: 31_000, gmv_high: 45_400, tier: 2, confidence: 0.65,
    assumptions: { aod_estimated: 35, platform_details: [{ platform: 'tiktok', handle: '@jenna.bakes' }], is_multi_platform: false, summary_text: 'Food & baking niche creator with high domestic audience.' },
    creator_analyses: {
      followers: 98_000, engagement_rate: 0.0635, avg_views: 31_200, primary_category: 'food',
      provider: 'modash', profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=jenna&backgroundColor=ffd400',
      audience_gender_affinity: 'female', audience_age_min: 24, audience_age_max: 45,
      geo_top_countries: [{ country: 'US', pct: 0.68 }, { country: 'AU', pct: 0.1 }],
      interests_ranked: makeInterests(['Food & Cooking', 'Baking', 'Home & Kitchen', 'Recipes', 'Lifestyle']),
      brand_affinity_ranked: makeBrands(['KitchenAid', 'Whole Foods', 'Williams Sonoma', 'Lodge', 'Le Creuset']),
      derived_features: null,
      creators: { platform: 'tiktok', handle: '@jenna.bakes', profile_url: 'https://www.tiktok.com/@jenna.bakes' },
    },
  },
  {
    id: 1005, created_at: '2025-03-12T08:55:00Z',
    gmv_low: 8_400, gmv_expected: 14_000, gmv_high: 20_500, tier: 3, confidence: 0.58,
    assumptions: { aov_estimated: 30, platform_details: [{ platform: 'instagram', handle: '@aarondrawing' }], is_multi_platform: false, summary_text: 'Art & illustration micro-influencer with niche audience.' },
    creator_analyses: {
      followers: 52_000, engagement_rate: 0.0781, avg_views: null, primary_category: 'art',
      provider: 'modash', profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=aaron&backgroundColor=111',
      audience_gender_affinity: 'mixed', audience_age_min: 16, audience_age_max: 30,
      geo_top_countries: [{ country: 'US', pct: 0.35 }, { country: 'UK', pct: 0.20 }, { country: 'DE', pct: 0.1 }],
      interests_ranked: makeInterests(['Art & Design', 'Illustration', 'Stationery', 'DIY Crafts', 'Animation']),
      brand_affinity_ranked: makeBrands(['Adobe', 'Wacom', 'Staedtler', 'Moleskine', 'Procreate']),
      derived_features: null,
      creators: { platform: 'instagram', handle: '@aarondrawing', profile_url: 'https://www.instagram.com/aarondrawing' },
    },
  },
  {
    id: 1006, created_at: '2025-03-10T14:10:00Z',
    gmv_low: 52_200, gmv_expected: 87_000, gmv_high: 127_300, tier: 1, confidence: 0.74,
    assumptions: { aov_estimated: 48, platform_details: [{ platform: 'tiktok', handle: '@dani.wellness' }, { platform: 'instagram', handle: '@dani.wellness' }], is_multi_platform: true, summary_text: 'Wellness & self-care creator with high purchase intent.' },
    creator_analyses: {
      followers: 321_000, engagement_rate: 0.0447, avg_views: 62_400, primary_category: 'wellness',
      provider: 'modash', profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=dani&backgroundColor=ffd400',
      audience_gender_affinity: 'female', audience_age_min: 22, audience_age_max: 40,
      geo_top_countries: [{ country: 'US', pct: 0.49 }, { country: 'UK', pct: 0.15 }, { country: 'AU', pct: 0.1 }],
      interests_ranked: makeInterests(['Wellness & Self-Care', 'Skincare', 'Yoga & Meditation', 'Nutrition', 'Mental Health']),
      brand_affinity_ranked: makeBrands(['Glossier', 'The Ordinary', 'Lululemon', 'Goop', 'Ritual']),
      derived_features: null,
      creators: { platform: 'tiktok', handle: '@dani.wellness', profile_url: 'https://www.tiktok.com/@dani.wellness' },
    },
  },
  {
    id: 1007, created_at: '2025-03-07T10:30:00Z',
    gmv_low: 27_800, gmv_expected: 46_300, gmv_high: 67_800, tier: 2, confidence: 0.68,
    assumptions: { aov_estimated: 40, platform_details: [{ platform: 'youtube', handle: '@CookingWithRaj' }], is_multi_platform: false, summary_text: 'Indian-American foodie with wide domestic reach.' },
    creator_analyses: {
      followers: 234_000, engagement_rate: 0.0388, avg_views: 55_100, primary_category: 'food',
      provider: 'modash', profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=raj&backgroundColor=0b0b0b',
      audience_gender_affinity: 'mixed', audience_age_min: 25, audience_age_max: 45,
      geo_top_countries: [{ country: 'US', pct: 0.44 }, { country: 'IN', pct: 0.28 }, { country: 'CA', pct: 0.1 }],
      interests_ranked: makeInterests(['Food & Cooking', 'Indian Cuisine', 'Home & Kitchen', 'Travel', 'Culture']),
      brand_affinity_ranked: makeBrands(['Instant Pot', 'Vitamix', 'Trader Joes', 'Whole Foods', 'KitchenAid']),
      derived_features: null,
      creators: { platform: 'youtube', handle: '@CookingWithRaj', profile_url: 'https://www.youtube.com/@CookingWithRaj' },
    },
  },
  {
    id: 1008, created_at: '2025-03-04T16:00:00Z',
    gmv_low: 72_500, gmv_expected: 120_800, gmv_high: 176_900, tier: 1, confidence: 0.80,
    assumptions: { aov_estimated: 44, platform_details: [{ platform: 'instagram', handle: '@emilystyle' }], is_multi_platform: false, summary_text: 'Fashion & sustainability advocate with premium audience.' },
    creator_analyses: {
      followers: 489_000, engagement_rate: 0.0358, avg_views: null, primary_category: 'fashion',
      provider: 'modash', profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=emily&backgroundColor=ffd400',
      audience_gender_affinity: 'female', audience_age_min: 22, audience_age_max: 38,
      geo_top_countries: [{ country: 'US', pct: 0.40 }, { country: 'UK', pct: 0.22 }, { country: 'AU', pct: 0.11 }],
      interests_ranked: makeInterests(['Fashion & Style', 'Sustainability', 'Luxury', 'Travel', 'Art & Design']),
      brand_affinity_ranked: makeBrands(['Net-a-Porter', 'Reformation', 'Everlane', 'Staud', 'Sezane']),
      derived_features: null,
      creators: { platform: 'instagram', handle: '@emilystyle', profile_url: 'https://www.instagram.com/emilystyle' },
    },
  },
];

// ── Vendor Creators ──────────────────────────────────────────────────────

export const DEMO_VENDOR_CREATORS = [
  {
    id: 1,
    influencer_id: 'sophiachen',
    slug: 'sophiachen',
    stage_name: 'Sophia Chen',
    platform: 'tiktok',
    category: 'fashion',
    follower_count: 284_000,
    engagement_rate: 0.0522,
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=sophia&backgroundColor=ffd400',
    orders: 84,
    revenue: 12_432,
    top_product: 'Premium Bamboo Tote Bag',
    last_active: '2026-04-09',
  },
  {
    id: 2,
    influencer_id: 'marcuslee',
    slug: 'marcuslee',
    stage_name: 'Marcus Lee',
    platform: 'instagram',
    category: 'fitness',
    follower_count: 193_000,
    engagement_rate: 0.0418,
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=marcus&backgroundColor=4ade80',
    orders: 71,
    revenue: 9_867,
    top_product: 'Minimalist Phone Stand (Blk)',
    last_active: '2026-04-08',
  },
  {
    id: 3,
    influencer_id: 'aishapatel',
    slug: 'aishapatel',
    stage_name: 'Aisha Patel',
    platform: 'tiktok',
    category: 'beauty',
    follower_count: 156_000,
    engagement_rate: 0.0631,
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=aisha&backgroundColor=a78bfa',
    orders: 58,
    revenue: 7_540,
    top_product: 'Organic Cotton Hoodie — Oat',
    last_active: '2026-04-07',
  },
  {
    id: 4,
    influencer_id: 'lunapark',
    slug: 'lunapark',
    stage_name: 'Luna Park',
    platform: 'youtube',
    category: 'lifestyle',
    follower_count: 412_000,
    engagement_rate: 0.032,
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=luna&backgroundColor=3b82f6',
    orders: 112,
    revenue: 15_890,
    top_product: 'Ceramic Tumbler Set × 2',
    last_active: '2026-04-06',
  },
  {
    id: 5,
    influencer_id: 'ethanbrooks',
    slug: 'ethanbrooks',
    stage_name: 'Ethan Brooks',
    platform: 'instagram',
    category: 'tech',
    follower_count: 89_000,
    engagement_rate: 0.057,
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=ethan&backgroundColor=f87171',
    orders: 33,
    revenue: 4_210,
    top_product: 'Minimalist Phone Stand (Blk)',
    last_active: '2026-04-05',
  },
  {
    id: 6,
    influencer_id: 'miatorres',
    slug: 'miatorres',
    stage_name: 'Mia Torres',
    platform: 'tiktok',
    category: 'food',
    follower_count: 327_000,
    engagement_rate: 0.071,
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=mia&backgroundColor=14b8a6',
    orders: 92,
    revenue: 11_240,
    top_product: 'Bamboo Cutlery Travel Kit',
    last_active: '2026-04-04',
  },
  {
    id: 7,
    influencer_id: 'noahkim',
    slug: 'noahkim',
    stage_name: 'Noah Kim',
    platform: 'youtube',
    category: 'gaming',
    follower_count: 510_000,
    engagement_rate: 0.028,
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=noah&backgroundColor=ec4899',
    orders: 67,
    revenue: 8_670,
    top_product: 'Canvas Belt Bag — Sand',
    last_active: '2026-04-03',
  },
  {
    id: 8,
    influencer_id: 'jasminewu',
    slug: 'jasminewu',
    stage_name: 'Jasmine Wu',
    platform: 'instagram',
    category: 'beauty',
    follower_count: 178_000,
    engagement_rate: 0.049,
    profile_image_url: 'https://api.dicebear.com/8.x/avataaars/svg?seed=jasmine&backgroundColor=6366f1',
    orders: 48,
    revenue: 6_380,
    top_product: 'Recycled Denim Crossbody',
    last_active: '2026-04-02',
  },
];

// ── Vendor Creator Detail ────────────────────────────────────────────────

export const DEMO_VENDOR_CREATOR_DETAIL = {
  ...DEMO_VENDOR_CREATORS[0],
  bio: 'Fashion-forward content creator sharing sustainable style tips and eco-conscious living. Based in Los Angeles.',
  joined_date: '2025-09-15',
  products_sold: [
    { product_title: 'Premium Bamboo Tote Bag', units: 142, revenue: 4_970, pct_of_total: 0.40 },
    { product_title: 'Organic Cotton Hoodie — Oat', units: 98, revenue: 5_390, pct_of_total: 0.43 },
    { product_title: 'Recycled Denim Crossbody', units: 24, revenue: 1_320, pct_of_total: 0.11 },
    { product_title: 'Ceramic Tumbler Set × 2', units: 14, revenue: 752, pct_of_total: 0.06 },
  ],
  revenue_trend: (() => {
    const out: Array<{ date: string; revenue: number; orders: number }> = [];
    const base = Date.now() - 29 * 86400000;
    for (let i = 0; i < 30; i++) {
      const d = new Date(base + i * 86400000);
      const rev = 300 + Math.sin(i * 0.5) * 120 + Math.random() * 80;
      out.push({ date: d.toISOString().slice(0, 10), revenue: Math.round(rev), orders: Math.round(rev / 148) });
    }
    return out;
  })(),
  avg_creator_revenue: 8_900,
};

// ── Vendor Payouts ───────────────────────────────────────────────────────

export const DEMO_VENDOR_PAYOUTS = {
  balance: 8_420.50,
  currency: 'USD',
  next_payout_date: (() => {
    const d = new Date();
    d.setDate(15);
    if (d < new Date()) d.setMonth(d.getMonth() + 1);
    return d.toISOString().slice(0, 10);
  })(),
  next_payout_amount: 8_420.50,
  total_paid: 47_680.00,
  pending_amount: 2_340.00,
  payouts: [
    { id: 1, amount: 9_240.00, status: 'paid', requested_at: '2026-03-01T00:00:00Z', processed_at: '2026-03-15T00:00:00Z', notes: null },
    { id: 2, amount: 8_120.00, status: 'paid', requested_at: '2026-02-01T00:00:00Z', processed_at: '2026-02-15T00:00:00Z', notes: null },
    { id: 3, amount: 7_650.00, status: 'paid', requested_at: '2026-01-01T00:00:00Z', processed_at: '2026-01-15T00:00:00Z', notes: null },
    { id: 4, amount: 6_890.00, status: 'paid', requested_at: '2025-12-01T00:00:00Z', processed_at: '2025-12-15T00:00:00Z', notes: null },
    { id: 5, amount: 8_340.00, status: 'paid', requested_at: '2025-11-01T00:00:00Z', processed_at: '2025-11-15T00:00:00Z', notes: null },
    { id: 6, amount: 7_440.00, status: 'paid', requested_at: '2025-10-01T00:00:00Z', processed_at: '2025-10-15T00:00:00Z', notes: null },
  ],
  ledger: (() => {
    const entries: Array<{ id: number; entry_type: string; amount: number; description: string; reference_type: string; reference_id: string; created_at: string }> = [];
    let id = 1;
    const base = Date.now() - 30 * 86400000;
    for (let i = 0; i < 25; i++) {
      const d = new Date(base + i * 86400000 + Math.random() * 86400000);
      const isSale = Math.random() > 0.15;
      entries.push({
        id: id++,
        entry_type: isSale ? 'sale' : (Math.random() > 0.5 ? 'refund' : 'fee'),
        amount: isSale ? Math.round((40 + Math.random() * 200) * 100) / 100 : -Math.round((10 + Math.random() * 50) * 100) / 100,
        description: isSale ? `Order #${20000 + i}` : (Math.random() > 0.5 ? `Refund #${20000 + i}` : 'Platform fee'),
        reference_type: 'order',
        reference_id: String(20000 + i),
        created_at: d.toISOString(),
      });
    }
    return entries.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
  })(),
  monthly_breakdown: [
    { month: '2026-03', earnings: 9_240.00, deductions: -820.00, net: 8_420.00 },
    { month: '2026-02', earnings: 8_650.00, deductions: -530.00, net: 8_120.00 },
    { month: '2026-01', earnings: 8_100.00, deductions: -450.00, net: 7_650.00 },
    { month: '2025-12', earnings: 7_340.00, deductions: -450.00, net: 6_890.00 },
    { month: '2025-11', earnings: 8_740.00, deductions: -400.00, net: 8_340.00 },
    { month: '2025-10', earnings: 7_890.00, deductions: -450.00, net: 7_440.00 },
  ],
};

// ── Vendor Forecasts ──────────────────────────────────────────────────────

export const DEMO_VENDOR_FORECASTS = {
  annual_revenue: 742_000,
  annual_units: 14_280,
  growth_rate: 0.18,
  months: (() => {
    const monthNames = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    const baseRevenue = [48000, 52000, 58000, 55000, 62000, 68000, 72000, 65000, 70000, 75000, 80000, 37000];
    return monthNames.map((name, i) => ({
      month: `2026-${String(i + 1).padStart(2, '0')}`,
      label: name,
      revenue: baseRevenue[i],
      units: Math.round(baseRevenue[i] / 52),
      recommended_production: Math.round(baseRevenue[i] / 52 * 1.15),
      status: i === 6 ? 'at_risk' as const : i === 11 ? 'critical' as const : 'on_track' as const,
    }));
  })(),
  product_forecasts: [
    { product_id: 'p1', product_title: 'Premium Bamboo Tote Bag', current_stock: 420, projected_demand: 380, surplus_deficit: 40, days_of_supply: 33 },
    { product_id: 'p2', product_title: 'Organic Cotton Hoodie — Oat', current_stock: 85, projected_demand: 290, surplus_deficit: -205, days_of_supply: 9 },
    { product_id: 'p3', product_title: 'Minimalist Phone Stand (Blk)', current_stock: 310, projected_demand: 260, surplus_deficit: 50, days_of_supply: 36 },
    { product_id: 'p4', product_title: 'Recycled Denim Crossbody', current_stock: 45, projected_demand: 210, surplus_deficit: -165, days_of_supply: 6 },
    { product_id: 'p5', product_title: 'Ceramic Tumbler Set × 2', current_stock: 200, projected_demand: 180, surplus_deficit: 20, days_of_supply: 33 },
    { product_id: 'p6', product_title: 'Bamboo Cutlery Travel Kit', current_stock: 150, projected_demand: 120, surplus_deficit: 30, days_of_supply: 38 },
  ],
};
